import { RenterProfileModel } from './Types';

const RenterModel = (renter: RenterProfileModel) => {
  const { firstName = '', lastName = '', email = '' } = renter || {};
  const name = `${firstName.trim()} ${lastName.trim()}`;

  return {
    firstName: firstName.trim(),
    lastName: lastName.trim(),
    name,
    email,
  };
};

export default RenterModel;
